<div class="d-flex mt-4">
      <div class="flex-fill">
        <h1>Reportes</h1>
        <p>Consulta la información del sistema.</p>
      </div>
    </div>
    <div class="d-flex">
      <div #pages class="flex-fill">
        <div class="d-flex">
          <div class="flex-fill">
            <ul class="list-group mt-4">
              <li class="list-group-item">
                <div class="d-flex justify-content-between align-items-center p-3">
                  <div class="flex-fill">Cuentas por cobrar</div>
                    <div class="text-end">
                      <button type="button" 
                        class="btn btn-zazz-dark"
                        routerLink="accounts-receivable"
                      >
                        Ver cuentas por cobrar
                      </button>
                    </div>
                  </div>
              </li>
              <li class="list-group-item">
                <div class="d-flex justify-content-between align-items-center p-3">
                  <div class="flex-fill">Reporte de liquidación Openpay</div>
                  <div class="text-end">
                    <button
                      type="button"
                      class="btn btn-zazz-dark"
                      routerLink="openpay-liquidations"
                    >
                      Ver liquidaciones
                    </button>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="d-flex justify-content-between align-items-center p-3">
                  <div class="flex-fill">Reporte de consumos irregulares</div>
                  <div class="text-end">
                    <button type="button" 
                      class="btn btn-zazz-dark"
                      routerLink="irregular-consumptions">
                      Navegar
                    </button>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="d-flex justify-content-between align-items-center p-3">
                  <div class="flex-fill">Reporte de lecturas Anova</div>
                  <div class="text-end">
                    <button type="button" 
                      class="btn btn-zazz-dark"
                      routerLink="irregular-consumptions-tanks">
                      Navegar
                    </button>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="d-flex justify-content-between align-items-center p-3">
                  <div class="flex-fill">Reporte Global Comercial</div>
                  <div class="text-end">
                    <button type="button" 
                      class="btn btn-zazz-dark"
                      routerLink="condominium-commercial-report">
                      Navegar
                    </button>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="d-flex justify-content-between align-items-center p-3">
                  <div class="flex-fill">Reporte Global Habitacional</div>
                  <div class="text-end">
                    <button type="button" 
                      class="btn btn-zazz-dark"
                      routerLink="condominium-hab-report">
                      Navegar
                    </button>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="d-flex justify-content-between align-items-center p-3">
                  <div class="flex-fill">Reporte Habitacional Tanques</div>
                  <div class="text-end">
                    <button type="button" 
                      class="btn btn-zazz-dark"
                      routerLink="housing-tanks-report">
                      Navegar
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="flex-fill"></div>
        </div>
      </div>
    </div>
